<template>
  <v-app>
    <SideBar
      ref="sidebar"
      min-width="300"
      :factory_info="factory_info"
      :user_info="user_info"
    ></SideBar>

    <AppBar
      :user_info="user_info"
      ref="appbar"
      class="px-4 px-lg-6"
      @update="load_user_info"
    ></AppBar>

    <v-main
      class="mb-16 pb-4 mb-lg-0 pb-lg-0"
      style="position: relative;"
    >      
      <router-view
        :user_info="user_info"
        :factory_info="factory_info"
        class="px-lg-6 px-4 text-N700"
      ></router-view>

      <v-tour ref="tour"></v-tour>
      <v-expand-transition>
        <v-card
          v-show="deferredPrompt"
          color="primary-50"
          position="fixed"
          :title="$t('sse_monitait_app')"
          :text="$t('better_more_comprehensive_user_experience')"
          stacked
          class="px-6 py-4 elevation-16"
          style="z-index: 10000;"
          :class="$store.state.desktop ? 'w-25 rounded-t-lg' : 'w-100 rounded-b-lg'"
          :style="$store.state.desktop ? 'bottom: 0; left: 37.5%;' : 'top: 0; left: 0;'"
        >
          <template v-slot:actions>
            <v-btn text @click="dismiss">{{ $t('dismiss') }}</v-btn>
            <v-btn color="primary" text @click="install">{{ $t('install') }}</v-btn>
          </template>
        </v-card>
      </v-expand-transition>
    </v-main>

    <ChargeWallet
      :unit="user_info.balance?.currancy_symbol"
      :user_info="user_info"
    ></ChargeWallet>

    <EditProfile
      :user_info="user_info"
      :factory_info="factory_info"
      @update="load_user_info"
      @factory_update="load_factory_info"
    ></EditProfile>
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar';
import SideBar from '@/components/SideBar';
import VTour from '@/components/VTour.vue';
import ChargeWallet from './Factory/dialog/ChargeWallet.vue';
import EditProfile from '@/components/EditProfile.vue';
import api from '@/api';
import jwtDecode from 'jwt-decode';
import Cookies from "js-cookie";

export default {
  name: "DashboardView",
  components: {
    AppBar,
    SideBar,
    VTour,
    ChargeWallet,
    EditProfile,
  },
  data: () => ({
    user_info: {},
    deferredPrompt: null,
    factory_info: {}
  }),
  computed: {
    is_factory() {
      let user_info = jwtDecode(localStorage.getItem("access")).user_info
      return user_info.is_admin || user_info.is_verify_operator || user_info.is_buyer
    },
    user_id() {
      return jwtDecode(localStorage.getItem("access")).user_id
    }
  },
  created() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      if (Cookies.get("add-to-home-screen") === undefined) {
        this.deferredPrompt = e;
      }
    });
    window.addEventListener("appinstalled", () => {
      this.deferredPrompt = null;
    });
  },
  mounted() {
    this.load_user_info()
    this.load_factory_info()
  },
  methods: {
    load_user_info() {
      api.userInfo(this.user_id).then(res => {
        this.user_info = res.data
      })
    },
    load_factory_info() {
      if (this.is_factory) {
        api.factoryInfo().then(res => {
          this.$store.state.factoryInfo = this.factory_info = res.data
        })
      }
    },
    async dismiss() {
      Cookies.set("add-to-home-screen", null, { expires: 10 });
      this.deferredPrompt = null;
    },
    async install() {
      Cookies.set("add-to-home-screen", true, { expires: 10 });
      this.deferredPrompt.prompt();
    },
  }
}
</script>
